import { definePinoWebTransport } from '../../definePinoWebTransport';
import { applicationInsightsTransportHandlers } from './applicationInsightsTransportHandlers';
import { checkForApplicationInsights } from './checkForApplicationInsights';
const applicationInsightsWebTransform = definePinoWebTransport(applicationInsightsTransportHandlers, checkForApplicationInsights);
export default applicationInsightsWebTransform;
//# sourceMappingURL=applicationInsightsWebTransport.js.map